import { getDeviceStore } from '../storage/stores';
import { refreshProtectionStatus } from '../protectionStatus';

export const isSafeNetworkDelegated = () =>
  getDeviceStore().isSafeNetworkDelegated();

export const undelegateBySafeNetwork = () =>
  updateSafeNetworkDelegationState(false);
export const delegateBySafeNetwork = () =>
  updateSafeNetworkDelegationState(true);

const updateSafeNetworkDelegationState = (delegated: boolean) => {
  console.log(
    `Changing Safe Network delegation state! delegated = ${delegated}`
  );
  getDeviceStore().setIsSafeNetworkDelegated(delegated);
  // We want to refresh the protection, but without checking the Safe Network state again.
  const context = delegated ? 'enter-safe-network' : 'leaving-safe-network';
  return refreshProtectionStatus(false, context);
};
